import React, { useState } from 'react';
import PropertyCard from './PropertyCard';

const properties = [
  { id: 1, type: 'Furnished 4 bedroom', category: 'For Sale', rooms: 4, baths: 5, price: '₦95,000,000', distance: '15 min', img: 'images/4bed.jpeg'},
  { id: 2, type: 'Block of Flats', category: 'For Rent', rooms: 3, baths: 4, price: '₦300,000/year', distance: '10 min', img: 'images/oip.jpeg' },
  { id: 3, type: '100acres Land', category: 'For Sale', rooms: 0, baths: 0, price: '₦10,000,000/acre', distance: '22 min', img: 'images/r.jpeg' },
  { id: 7, type: 'Semi-detached Duplex', category: 'For Sale', rooms: 4, baths: 4, price: '₦150,000,000', distance: '15 min', img: 'images/bed3.png' },
  { id: 6, type: 'Plots of Land', category: 'For Sale', rooms: 0, baths: 0, price: '₦5,000,000/plot', distance: '20 min', img: 'images/oip (1).jpeg' },
  { id: 12, type: '3 Bedroom Bungalow', category: 'For Rent', rooms: 3, baths: 2, price: '₦450,000/year', distance: '10 min', img: 'images/R (1).jpeg' },

];

const FeaturedProperty = () => {
  const [filter, setFilter] = useState('All');

  const filteredProperties = properties.filter(property => 
    filter === 'All' || property.category === filter
  );

  return (
    <section className="featured-property" data-aos="fade-up" >
      <h2>Featured Properties</h2>
      <div className="filter-buttons">
        <button 
          onClick={() => setFilter('All')} 
          className={filter === 'All' ? 'active' : ''}
        >
          All
        </button>
        <button 
          onClick={() => setFilter('For Rent')} 
          className={filter === 'For Rent' ? 'active' : ''}
        >
          For Rent
        </button>
        <button 
          onClick={() => setFilter('For Sale')} 
          className={filter === 'For Sale' ? 'active' : ''}
        >
          For Sale
        </button>
      </div>

      <div className="property-list">
        {filteredProperties.map(property => (
          <PropertyCard key={property.id} property={property} />
        ))}
      </div>
    </section>
  );
};

export default FeaturedProperty;
